import {Tekstmal} from '../../../models/tekstmal';
import {client} from '../../client';
import RequestService, {getQueryURL, uploadFile} from '../requestService';
import {FilterQueries} from '../../../app/utils/filter';


export default class TekstmalService extends RequestService<Tekstmal, 'tekstmal'> {
    renameFile = async (fraFilnavn: string, tilFilnavn: string) => await client.get<string>(getQueryURL(`${this.serviceName}/fil-endre-navn`, {fraFilnavn, tilFilnavn}));
    deleteFile = async (filnavn: string) =>  await client.delete(getQueryURL(`${this.serviceName}/fil-slett`, {filnavn}));
    checkExistFile = async (filnavn: string) =>  await client.get<boolean>(getQueryURL(`${this.serviceName}/fil-finnes`, {filnavn}));
    getAvailibleTekstmalListe = async (filter: FilterQueries, searchString?: string) => await client.post(getQueryURL(`${this.serviceName}/fil-liste`, {q: searchString}), filter);
    loadFile = async (filnavn: string) => await client.getFile(getQueryURL(`${this.serviceName}/faa_innhold`, {filnavn}), 'GET');
    loadPdfContent = async (filnavn: string) => await client.getFile(getQueryURL(`${this.serviceName}/faa_pdf_innhold`, {filnavn}), 'GET');
    uploadFile =  async (filnavn: string, fileContent: Blob) => await uploadFile(getQueryURL(`${this.serviceName}/lagre_fil`, {filnavn}), fileContent);
}
 